import {
  FunctionComponent,
  useCallback,
  useState,
  SyntheticEvent,
  ReactNode,
} from 'react'
import { Box, Tabs, Tab, Typography, ClassNameMap } from '@mui/material'
import { Translation, useWidgetContext } from '@dxp-module/common'
import { MaTabContainerClasses } from '@dxp-module/themes'
import clsx from 'clsx'
import { AccountOptions } from '../../enum/AccountOptions'
import TabPanel from './TabPanel'
import tabContainerStyles from './tabContainer.styles'

type TabProps = {
  value: AccountOptions
  title: string
  component: ReactNode | JSX.Element
}

type TabContainerProps = {
  tabs: TabProps[]
  classes?: Partial<ClassNameMap<MaTabContainerClasses>>
  'data-test': string
}

const TabContainer: FunctionComponent<TabContainerProps> = ({
  tabs,
  classes,
  'data-test': dataTest,
}) => {
  const {
    configuration: { activeTab },
  } = useWidgetContext()
  const activeTabChosen =
    activeTab === AccountOptions.REGISTER
      ? AccountOptions.REGISTER
      : AccountOptions.LOGIN
  const [active, setActive] = useState<AccountOptions>(activeTabChosen)
  const styles = tabContainerStyles()

  const handleChange = useCallback(
    (_: SyntheticEvent, newValue: AccountOptions) => {
      setActive(newValue)
    },
    []
  )

  return (
    <Box className={clsx([styles.root, classes?.root])} data-test={dataTest}>
      <Tabs
        className={clsx([styles.tabs, classes?.tabs])}
        value={active}
        onChange={handleChange}
      >
        {tabs.map(tab => (
          <Tab
            key={tab.value}
            className={clsx([styles.tab, classes?.tab])}
            label={
              <Typography>
                <Translation id={tab.title} className={styles.tabText} />
              </Typography>
            }
            value={tab.value}
            data-test={`${dataTest}:tabs:${tab.value}`}
          />
        ))}
      </Tabs>
      {tabs.map((tab, keyIndex) => (
        <TabPanel
          key={keyIndex}
          className={clsx([styles.tabPanel, classes?.tabPanel])}
          value={active}
          index={tab.value}
        >
          {tab.component}
        </TabPanel>
      ))}
    </Box>
  )
}

export default TabContainer
